import { PortalPageContent, PortalPageContentHeader } from "@fero/layouts";
import { AppRoutes } from "@fero/utils";
import { Button, Stack } from "@mui/material";
import { ImportPriceListButton, ProductsTable } from "./components";

export const ProductsPage = () => {
  return (
    <PortalPageContent
      header={
        <PortalPageContentHeader
          variant="split"
          title="Products"
          right={
            <Stack direction="row" spacing={2} justifyContent={"flex-end"}>
              <ImportPriceListButton />
              <Button href={AppRoutes.CreateNewDealRequest}>
                Add Products
              </Button>
            </Stack>
          }
        />
      }
    >
      <ProductsTable />
    </PortalPageContent>
  );
};
